import { HttpClient } from "@angular/common/http";

export interface ApiServiceConfig {
	http: HttpClient;
	baseUrl: string;
}
